module.exports = __webpack_public_path__ + "static/media/ProfessionalData.4825aa2d.svg";